<template>
  <TheAppBar
    v-model:support-panel="supportPanel"
    :hide-logo="smAndDown"
    :is-mobile="device?.isMobile"
  />

  <DeepSupportPanel v-model="supportPanel" />

  <v-main>
    <div class="page-wrapper">
      <ContainerContentOrError>
        <router-view />
      </ContainerContentOrError>
    </div>
  </v-main>
</template>

<script lang="ts" setup>
import { useDisplay } from 'vuetify/framework'
import { DeviceKey } from '@/plugins/device-detector-js.ts'
import TheAppBar from '@/components/appbar/TheAppBar.vue'
import ContainerContentOrError from '@/components/containers/ContainerContentOrError.vue'
import DeepSupportPanel from '@/components/DeepSupportPanel.vue'

const device = inject(DeviceKey)
const { smAndDown } = useDisplay()

const supportPanel = ref(false)
</script>

<style lang="scss" scoped>
.page-wrapper {
  height: 100%;
}
</style>
